export default {
	"RecommendGoods.rise": "rise",
	"RecommendGoods.purchase": "purchase"
}